import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from '@features/product/interfaces/product.interface';
import { ProductService } from '@features/product/services/product.service';
import { UserSkinfitAnalyseDialogComponent } from '@features/user/components/user-skinfit-analyse-dialog/user-skinfit-analyse-dialog.component';
import { Order } from '@features/user/interfaces/order.interface';
import {
  SkinFit,
  SkinFitContent,
} from '@features/user/interfaces/skin-fit.interface';
import { OrderService } from '@features/user/services/order.service';
import { SkinFitService } from '@features/user/services/skin-fit.service';
import {
  faArrowCircleRight,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { SkinFitType } from '@shared/enums/skin-fit.enum';
import { DialogService } from 'primeng/dynamicdialog';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css'],
})
export class UserDashboardComponent implements OnInit {
  faArrowCircleRight = faArrowCircleRight;
  faSpinner = faSpinner;
  faChevronRight = faChevronRight;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  shopDefaultImg = 'assets/images/shop/default-shop-logo.webp';
  productDefaultImg: string = 'assets/images/product/default-product.png';

  // Skin Fit
  skinFit: SkinFit = {} as SkinFit;
  skinFitContents: SkinFitContent[] = [
    {
      id: SkinFitType.ACNE,
      name: 'Acne',
      description:
        'Acne is caused when tiny holes in the skin, known as hair follicles, become blocked. Sebaceous glands are tiny glands found near the surface of your skin.',
      status: false,
      image: '/assets/images/skin-fit/acne.png',
      isActive: true,
      confidence: 0,
      colour: null,
    },
    {
      id: SkinFitType.BLACKHEAD,
      name: 'Blackhead',
      description:
        'Blackheads are small bumps that appear on your skin due to clogged hair follicles. These bumps are called blackheads because the surface looks dark or black. Blackheads are a mild type of acne that usually form on the face, but they can also appear on the body',
      status: false,
      image: '/assets/images/skin-fit/blackhead.png',
      isActive: false,
      confidence: 0,
      colour: null,
    },
    {
      id: SkinFitType.PORES_FOREHEAD,
      name: 'Pores Forehead',
      description:
        'While not a medical concern, open pores can be a cosmetic issue for some people who do not like the way their skin looks. In adolescents, and in adults who are prone to acne, open pores may become clogged, turning into blackheads or whiteheads.',
      status: false,
      image: '/assets/images/skin-fit/pores-forehead.png',
      isActive: false,
      confidence: 0,
      colour: null,
    },
    {
      id: SkinFitType.EYE_POUCH,
      name: 'Eye Pouch',
      description:
        'Eye Pouch or Bags under the eyes are seen as mild swelling in the skin below the eyes. How chronically the eye puffiness continues, really depends on the cause(s), and if these causes become resolved.',
      status: false,
      image: '/assets/images/skin-fit/eye-pouch.png',
      isActive: false,
      confidence: 0,
      colour: null,
    },
    {
      id: SkinFitType.DARK_CIRCLE,
      name: 'Dark Circle',
      description:
        'Dark circles under the eyes may look purple or blue to dark brown or black, depending on skin color.These circles are rarely a cause for concern, but people may wish to reduce their appearance for cosmetic reasons.',
      status: false,
      image: '/assets/images/skin-fit/dark-circle.png',
      isActive: false,
      confidence: 0,
      colour: null,
    },
    {
      id: SkinFitType.SKIN_SPOT,
      name: 'Dark Spot',
      description:
        'Age spots are flat brown, gray, or black spots on the skin. They usually occur on sun-exposed areas, like the backs of your hands and your face. Age spots are also called liver spots, senile lentigo, solar lentigines, or sun spots.',
      status: false,
      image: '/assets/images/skin-fit/skin-spot.png',
      isActive: false,
      confidence: 0,
      colour: null,
    },
    {
      id: SkinFitType.CROWS_FEET,
      name: 'Crows Feet',
      description: `“Crow's feet” is the term given to those fine lines around the eye area. These tiny wrinkles might also be known as “smile lines” since they're the ones that form when we grin.`,
      status: false,
      image: '/assets/images/skin-fit/crows-feet.png',
      isActive: false,
      confidence: 0,
      colour: null,
    },
    {
      id: null,
      name: 'Skin Color',
      description: `Skin tone is influenced by the content of pigment or melanin in the body. Everyone has a different content. Undertone is different from skin color, you know. People who have the same skin color don't necessarily have the same skin tone.`,
      colour: '63460D',
      status: false,
      image: null,
      isActive: false,
      confidence: 0,
    },
  ];
  selectedSkinFitContent: any;
  loadSkinFit: boolean = true;

  hideLoadMore = false;
  currentPage = 0;
  totalItems: number = 0;
  dateFilter = null;

  recomendProducts: any[] = [];
  selectedRecomendationProduct: string = 'all';
  loadRecomendationProduct: boolean = true;

  navSwiperConfig = {
    slidesPerView: 'auto',
    loop: false,
    loopedSlides: 1,
    freeMode: true,
    watchOverflow: true,
  };
  cleanserProducts: Product[] = [];
  tonerProducts: Product[] = [];
  creamProducts: Product[] = [];
  serumProducts: Product[] = [];
  sunscreenProducts: Product[] = [];
  cushionProducts: Product[] = [];

  recomendationSteps: any = [];

  constructor(
    private skinFitService: SkinFitService,
    private router: Router,
    private productService: ProductService,
    private dialogService: DialogService,
    private layoutService: LayoutService,
    private orderService: OrderService
  ) {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Dashboard',
          searchButton: false,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
  }

  ngOnInit(): void {
    this.getSkinFit();
    this.loadOrders();
  }

  ngOnDestroy(): void {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  getConfidencePercentage(confidence: number) {
    if (confidence == 1) {
      confidence = 1;
    } else if (confidence <= 0.005) {
      confidence = 0.01;
    } else if (confidence >= 0.995) {
      confidence = 0.99;
    }
    return confidence;
  }

  // Skin Fit Behavior
  getSkinFit() {
    this.loadSkinFit = true;
    this.skinFitService.getLatestSkinFit().subscribe(
      (data) => {
        if (data.response) {
          this.skinFit = data;
          const faceAnalyse = this.skinFit.response;
          this.skinFitContents[0].status = faceAnalyse.acne.acne == 'have acne';
          this.skinFitContents[0].confidence =
            this.getConfidencePercentage(faceAnalyse.acne.confidence) * 100;

          this.skinFitContents[1].status =
            faceAnalyse.blackhead.blackhead == 'have blackhead';
          this.skinFitContents[1].confidence =
            this.getConfidencePercentage(faceAnalyse.blackhead.confidence) *
            100;

          this.skinFitContents[2].status =
            faceAnalyse.pores_forehead.pores_forehead ==
            'forehead with large pores';
          this.skinFitContents[2].confidence =
            this.getConfidencePercentage(
              faceAnalyse.pores_forehead.confidence
            ) * 100;

          this.skinFitContents[3].status =
            faceAnalyse.eye_pouch.eye_pouch == 'have eye pouch';
          this.skinFitContents[3].confidence =
            this.getConfidencePercentage(faceAnalyse.eye_pouch.confidence) *
            100;

          this.skinFitContents[4].status =
            faceAnalyse.dark_circle.dark_circle == 'have dark circles';
          this.skinFitContents[4].confidence =
            this.getConfidencePercentage(faceAnalyse.dark_circle.confidence) *
            100;

          this.skinFitContents[5].status =
            faceAnalyse.skin_spot.skin_spot == 'have skin spot';
          this.skinFitContents[5].confidence =
            this.getConfidencePercentage(faceAnalyse.skin_spot.confidence) *
            100;

          this.skinFitContents[6].status =
            faceAnalyse.crows_feet.crows_feet == 'have crows feet';
          this.skinFitContents[6].confidence =
            this.getConfidencePercentage(faceAnalyse.crows_feet.confidence) *
            100;

          this.skinFitContents[7].colour = faceAnalyse.color_skin.value;
          this.selectedSkinFitContent = this.skinFitContents[0];
        } else {
          // console.log('belum ada');
        }
        this.loadSkinFit = false;
        // this.setRecomendationProduct();
      },
      (error) => {
        this.loadSkinFit = false;
      }
    );
  }

  selectFaceAnalization(i: number) {
    this.skinFitContents.map(
      (faceAnalization) => (faceAnalization.isActive = false)
    );
    this.skinFitContents[i].isActive = true;
    this.selectedSkinFitContent = this.skinFitContents[i];
  }
  openSkinFitModal() {
    let style = {};
    if (this.layoutService.isMobile$.value) {
      style = {
        'max-height': '100%',
        width: '100vh',
        height: '100vh',
        overflow: 'hidden',
      };
    } else {
      style = {
        width: '500px',
        height: '600px',
        'border-radius': '1rem',
        overflow: 'hidden',
      };
    }
    const ref = this.dialogService.open(UserSkinfitAnalyseDialogComponent, {
      dismissableMask: true,
      closable: true,
      showHeader: false,
      contentStyle: {
        padding: '0',
      },
      style: style,
    });
    ref.onClose.subscribe((isAnalysed: any) => {});
  }

  // Order Behavior
  loadOrder = true;
  loadOrders() {
    this.loadOrder = true;
    this.orderService.getOrders(3, 1, null, []).subscribe(
      (data) => {
        data.orders.forEach((x: any) => this.orders.push(x));
        this.loadOrder = false;
      },
      (error) => {
        this.loadOrder = false;
      }
    );
  }
  // setRecomendationProduct(problem:string = 'all'){
  //   let skinProblem = [];
  //   this.loadRecomendationProduct = true;
  //   switch (problem) {
  //     case 'acne':
  //       this.selectedRecomendationProduct = 'acne';
  //       skinProblem.push(SkinFitType.ACNE)
  //       break;
  //     case 'blackhead':
  //       this.selectedRecomendationProduct = 'blackhead';
  //       skinProblem.push(SkinFitType.BLACKHEAD)
  //       break;
  //     case 'darkSpot':
  //       this.selectedRecomendationProduct = 'darkSpot';
  //       skinProblem.push(SkinFitType.SKIN_SPOT)
  //       break;
  //     default:
  //       this.selectedRecomendationProduct = 'all';
  //       skinProblem.push(SkinFitType.ACNE)
  //       skinProblem.push(SkinFitType.BLACKHEAD)
  //       skinProblem.push(SkinFitType.SKIN_SPOT)

  //       break;
  //   }
  //     this.recomendationSteps = [];
  //     this.setCleanserRecomendationProduct(skinProblem);

  // }
  // setCleanserRecomendationProduct(skinProblem:any){
  //   this.cleanserProducts = [];
  //   let filter ={
  //     "all": [
  //       {"suitable_skinfits": skinProblem},
  //       {"category_filter_id":[25]}
  //     ],
  //     "any":[
  //       {"is_recommended": 1}
  //     ]
  //   }
  //   // this.productService.elasticSearchProducts(10,1,'',filter).subscribe((data:any)=>{
  //   //   this.cleanserProducts = data.products;
  //   //   this.cleanserProducts.length > 0 ? this.recomendationSteps.push({"title" : "Cleanser","product": this.cleanserProducts}): '';
  //   //   this.setTonerRecomendationProduct(skinProblem);
  //   // },e=>{
  //   //   this.setTonerRecomendationProduct(skinProblem);
  //   // })
  // }
  // setTonerRecomendationProduct(skinProblem:any){
  //   this.tonerProducts = [];
  //   let filter ={
  //     "all": [
  //       {"suitable_skinfits": skinProblem},
  //       {"category_filter_id":[26]}
  //     ],
  //     "any":[
  //       {"is_recommended": 1}
  //     ]
  //   }
  //   // this.productService.elasticSearchProducts(10,1,'',filter).subscribe((data:any)=>{
  //   //   this.tonerProducts = data.products;
  //   //   this.tonerProducts.length > 0 ? this.recomendationSteps.push({"title" : "Toner","product": this.tonerProducts}): '';
  //   //   this.setCreamRecomendationProuct(skinProblem);
  //   // },e=>{
  //   //   this.setCreamRecomendationProuct(skinProblem);
  //   // })
  // }
  // setCreamRecomendationProuct(skinProblem:any){
  //   this.creamProducts = [];
  //   let filter ={
  //     "all": [
  //       {"suitable_skinfits": skinProblem},
  //       {"category_filter_id":[30]}
  //     ],
  //     "any":[
  //       {"is_recommended": 1}
  //     ]
  //   }
  //   // this.productService.elasticSearchProducts(10,1,'',filter).subscribe((data:any)=>{
  //   //   this.creamProducts = data.products;
  //   //   this.creamProducts.length > 0 ? this.recomendationSteps.push({"title" : "Cream","product": this.creamProducts}): '';
  //   //   this.setSerumRecomendationProduct(skinProblem);
  //   // },e=>{
  //   //   this.setSerumRecomendationProduct(skinProblem);
  //   // })
  // }
  // setSerumRecomendationProduct(skinProblem:any){
  //   this.serumProducts = [];
  //   let filter ={
  //     "all": [
  //       {"suitable_skinfits": skinProblem},
  //       {"category_filter_id":[28]}
  //     ],
  //     "any":[
  //       {"is_recommended": 1}
  //     ],
  //   }
  //   // this.productService.elasticSearchProducts(5,1,'',filter).subscribe((data:any)=>{
  //   //   this.serumProducts = data.products;
  //   //   this.serumProducts.length > 0 ? this.recomendationSteps.push({"title" : "Serum","product": this.serumProducts}): '';
  //   //   this.setSunscreenRecomendationProduct(skinProblem);
  //   // },e=>{
  //   //   this.setSunscreenRecomendationProduct(skinProblem);
  //   // })
  // }
  // setSunscreenRecomendationProduct(skinProblem:any){
  //   this.sunscreenProducts = [];
  //   let filter ={
  //     "all": [
  //       {"suitable_skinfits": skinProblem},
  //       {"category_filter_id":[36]}
  //     ],
  //     "any":[
  //       {"is_recommended": 1}
  //     ],
  //   }
  //   // this.productService.elasticSearchProducts(10,1,'',filter).subscribe((data:any)=>{
  //   //   this.sunscreenProducts = data.products;
  //   //   this.sunscreenProducts.length > 0 ? this.recomendationSteps.push({"title" : "Sunscreen","product": this.sunscreenProducts}): '';
  //   //   this.setCushionRecomendationProduct(skinProblem);
  //   // },e=>{
  //   //   this.setCushionRecomendationProduct(skinProblem);
  //   // })
  // }
  // setCushionRecomendationProduct(skinProblem:any){
  //   this.cushionProducts = [];
  //   let filter ={
  //     "all": [
  //       {"suitable_skinfits": skinProblem},
  //       {"category_filter_id":[32]}
  //     ],
  //     "any":[
  //       {"is_recommended": 1}
  //     ]
  //   }
  //   // this.productService.elasticSearchProducts(10,1,'',filter).subscribe((data:any)=>{
  //   //   this.cushionProducts = data.products;
  //   //   this.cushionProducts.length > 0 ? this.recomendationSteps.push({"title" : "Cushion Foundation","product": this.cushionProducts}): '';
  //   //   this.loadRecomendationProduct = false;
  //   // },e=>{
  //   //   this.loadRecomendationProduct = false;
  //   // })
  // }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  handleShopImgError() {
    this.shopDefaultImg = 'assets/images/shop/default-shop-logo.webp';
  }
  handleProductImgError() {
    this.productDefaultImg = 'assets/images/product/default-product.png';
  }
  translateOrderStatus(status: number) {
    return this.orderService.translateOrderStatus(status);
  }
  orders: Order[] = [];

  pToggle: any = [];
  onPToggle(i: any) {
    if (this.pToggle[i] == true) {
      for (let index in this.pToggle) {
        this.pToggle[index] = false;
      }
    } else {
      for (let index in this.pToggle) {
        this.pToggle[index] = false;
      }
      this.pToggle[i] = true;
    }
  }
}
